export const toTitleCase = val => {
    const splitWords = val.split(' ').map(c => c.charAt(0).toUpperCase() + c.slice(1)).join(' ')

    return splitWords
}

export const kebabToTitle = val => {
    return val.split('-').map(c => c.charAt(0).toUpperCase() + c.slice(1)).join(' ')
}

export const toKebabCase = val => {
    return val.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase()
}

export const capitalise = str => str.charAt(0).toUpperCase() + str.slice(1)

export const chunkArray = (array, size) => {
    if (array.length <= size) return [array]

    return [array.slice(0, size), ...chunkArray(array.slice(size), size)]
}

export const formatMoney = val => new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
    }).format(val)

export const rgbToHex = rgb => {
    // Choose correct separator, ie rgba(255, 255, 255) vs rgba(255 255 255)
    let sep = rgb.indexOf(",") > -1 ? "," : " "

    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep)

    // 16 converts to hexidecimal
    let r = (+rgb[0]).toString(16),
        g = (+rgb[1]).toString(16),
        b = (+rgb[2]).toString(16)

    if (r.length == 1) r = `0${r}`
    if (g.length == 1) g = `0${g}`
    if (b.length == 1) b = `0${b}`

    return `#${r}${g}${b}`
}

export const parseVideo = url => {
// - Supported YouTube URL formats:
//   - http://www.youtube.com/watch?v=My2FRPA3Gf8
//   - http://youtu.be/My2FRPA3Gf8
//   - https://youtube.googleapis.com/v/My2FRPA3Gf8
// - Supported Vimeo URL formats:
//   - http://vimeo.com/25451551
//   - http://player.vimeo.com/video/25451551
// - Also supports relative URLs:
//   - //player.vimeo.com/video/25451551
    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/)

    let type
    if (RegExp.$3.indexOf('youtu') > -1) {
        type = 'youtube'
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
        type = 'vimeo'
    }

    return {
        type,
        id: RegExp.$6
    }
}


